import {configureStore} from "@reduxjs/toolkit";
import viewerModel from "../../entities/Viewer/Model/viewer";

export default configureStore({
    reducer: {
        viewer: viewerModel
    }
})